/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */
import Footer from './Footer';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';
import { GenerationRecords } from './GenerationRecords';
import { VideoGenCard } from './VideoGenCard';
import { AiAgentIcon } from './CustomIcons/AiAgentIcon';
import { ThemeSunIcon } from './CustomIcons/ThemeSunIcon';
import { GrokIcon } from './CustomIcons/GrokIcon';
import { Sora2Icon } from './CustomIcons/Sora2Icon';

export {
  AiAgentIcon,
  ThemeSunIcon,
  AvatarDropdown,
  AvatarName,
  Footer,
  GenerationRecords,
  GrokIcon,
  Question,
  SelectLang,
  Sora2Icon,
  VideoGenCard,
};
